import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import {
  BACKEND_URL,
  KEY_ACCESS_TOKEN,
  KEY_REFRESH_TOKEN,
  REFRESH_URL,
} from "../Helpers/constant";

export let axiosInstance: AxiosInstance;

export const getAxiosInstance = () => {
  axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: AxiosRequestConfig): any => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers = req.headers || {};

    if (token) {
      req.headers["Authorization"] = `Bearer ${token}`;
    }

    return req;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }

      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      try {
        const refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN);

        if (!refreshToken) {
          console.warn("No refresh token found, redirecting to login...");
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(error);
        }

        const res = await axios.post(
          REFRESH_URL,
          { refreshToken },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const { accessToken, refreshToken: newRefreshToken } = res.data;

        localStorage.setItem(KEY_ACCESS_TOKEN, accessToken.token);
        localStorage.setItem(KEY_REFRESH_TOKEN, newRefreshToken.token);

        error.config.headers["Authorization"] = `Bearer ${accessToken.token}`;

        return axiosInstance(error.config);
      } catch (err) {
        console.error("Token refresh failed:", err);
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }
  );

  return axiosInstance;
};

export const getOtp = async (data: object) => {
  const res: AxiosResponse = await axiosInstance.post(
    `/v1/auth/send/otp`,
    data
  );

  return res;
};

export const postContactUsForm = async (payload: any) => {
  try {
    const path = `/v1/application/contactUs`;
    const res: any = await axiosInstance.post(path, payload);
    return res;
  } catch (error) {
    return error;
  }
};

export const verifyOtp = async (data: object) => {
  const res: any = await axiosInstance.post(`/v1/auth/verify/otp`, data);
  return res;
};

export const getPlayerRegestrationWindow = () => {
  const res = axiosInstance.get(`/v1/application/player-registration-window`);
  return res;
};

export const verifyMCANumber = async (mcaNo: string) => {
  const res: AxiosResponse = await axiosInstance.get(
    `/v1/application/account/mca/${mcaNo}`
  );

  return res;
};

export const getContactDetails = (mcaNo: string) => {
  const res = axiosInstance.get(`/v1/application/contact/details/${mcaNo}`);
  return res;
};

export const getPlayerRegDetails = (playerId: any) => {
  const res = axiosInstance.get(
    `/v1/application/player-registration/details/${playerId}`
  );
  return res;
};

export const updateContactDetails = (mcaNo: string, data: object) => {
  const res = axiosInstance.put(
    `/v1/application/contact/update/${mcaNo}`,
    data
  );
  return res;
};

export const updatePlayerRegDetails = (regId: any, data: object) => {
  const res = axiosInstance.put(
    `/v1/application/player-registration/update/${regId}`,
    data
  );
  return res;
};

export const postPlayerRegestration = (data: object) => {
  const res = axiosInstance.post(`/v1/application/player-registration`, data);
  return res;
};

export const uploadFile = async ({
  file,
  type,
  mcaId,
  playerRegistrationId,
  documentFor,
}: {
  file: File;
  type: "profile" | "document";
  mcaId?: string;
  playerRegistrationId?: string;
  documentFor?: string;
}) => {
  const path = `/v1/application/upload`;
  const form = new FormData();
  form.append("file", file);
  form.append("type", type);

  if (type === "profile") {
    if (mcaId) {
      form.append("mcaId", mcaId);
    }
  }

  if (type === "document") {
    if (playerRegistrationId) {
      form.append("playerRegistrationId", playerRegistrationId);
    }
    if (documentFor) {
      form.append("documentFor", documentFor);
    }
  }

  const res: any = await axiosInstance.post(path, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/application/create/publicUrl`;
    const form = new FormData();
    form.append("file", data);
    const res: any = await axiosInstance.post(path, form);
    return res;
  } catch (error) {
    return error;
  }
};
